import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IOpenAccount } from '@interfaces/open-account/oa.interface';
import { RecaptchaMockResult } from '@interfaces/submit/submit.service.interface';
import { FMFResponse } from '@shared/services/fraud-micro-frontend/fmf.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class OpenAccountReviewService {
  constructor(private http: HttpClient) {}

  openAccountValidate(
    openAccountData: IOpenAccount,
    fmfResponse: FMFResponse,
    mockRecaptchaLevel: RecaptchaMockResult,
  ): Observable<boolean> {
    return this.http.post<boolean>(`secure/validate-oaa`, {
      ...openAccountData,
      fmfResponse,
      mockRecaptchaLevel,
    });
  }
}
